module.exports = __webpack_public_path__ + "img/conversion-rate-by-industry.6b3241bb.png";